import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MenuBarService {
  private readonly menu = signal<any>(null);

  public register(menu: any) {
    this.menu.set(menu);
  }

  public openFilter() {
    this.menu()?.onOpenFilter();
  }

  public openPanel() {
    this.menu()?.onOpenPanel();
  }

  public close() {
    this.menu()?.close();
  }

  public open() {
    this.menu()?.open();
  }
}
